export function errorMessageFromUnknown(error) {
    if (error instanceof Error)
        return error.message;
    if (typeof error === 'string')
        return error;
    if (typeof error === 'object' && error !== null && 'message' in error) {
        const message = error.message;
        if (typeof message === 'string')
            return message;
    }
    return null;
}
export function isLikelyTechnicalErrorMessage(message) {
    const trimmed = message.trim();
    if (trimmed.length === 0)
        return true;
    return [
        /\bHTTP\s*\d{3}\b/i,
        /\b(GET|POST|PUT|PATCH|DELETE)\s+\/[^\s]+/i,
        /\b\/api\/|\b\/me\/|\bapi\/auth\b/i,
        /\b[A-Z][A-Z0-9]+(?:_[A-Z0-9]+)+\b/,
        /\b(statusCode|requestId|stack trace|SQLSTATE|ZodError)\b/i,
        /\b(ECONN|ENOTFOUND|ETIMEDOUT|EPERM|EADDR)\b/i,
        /\b(fetch failed|failed to fetch|network request failed|unexpected empty response)\b/i,
        /^\s*(Error|TypeError|SyntaxError|AbortError|AggregateError):/i,
    ].some((pattern) => pattern.test(trimmed));
}
export function friendlyErrorMessage(error, fallback) {
    const message = errorMessageFromUnknown(error);
    if (!message || isLikelyTechnicalErrorMessage(message))
        return fallback;
    return message;
}
export function isEmailVerificationError(error) {
    const message = errorMessageFromUnknown(error)?.toLowerCase() ?? '';
    return message.includes('verif') || message.includes('confirm');
}
//# sourceMappingURL=error-copy.js.map